import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {FITHParsedGameData} from "../../server/data/FITHParsedGameData";
import {FITHGameMode} from "../../gameMode/FITHGameMode";

export class FITHFreeSpinOutroController extends FreespinOutroController {

    protected calculateIsTriggered(data: FITHParsedGameData): boolean {
        return data.mode === FITHGameMode.BONUS && data.freespinsLeft === 0;
    }
}